/* eslint-disable no-param-reassign */
import { Checkboxes, Details } from 'nhsuk-react-components';
import { useEffect } from 'react';
import { Iteration } from '../../schemas/Iteration.schema';
import { commsTypeToLabel } from '../../utils/formattingUtils';
import { CheckboxItem } from './CheckboxItem';
import { ITERATION_DETAILS, SECTIONS } from './Constants';

interface IterationDetailsSectionProps {
    iteration: Iteration;
    checkedItems: Record<string, boolean>;
    sectionChecked: boolean;
    onSectionChange: (id: string) => void;
    handleCheckboxChange: (sectionKey: string, id: string) => void;
}

function IterationDetailsSection({
  iteration,
  checkedItems,
  sectionChecked,
  onSectionChange,
  handleCheckboxChange,
}: IterationDetailsSectionProps) {
  const id = SECTIONS.ITERATION_DETAILS;

  const selectedItems = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    checkedItems[ITERATION_DETAILS.COMMUNICATION] = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Checkboxes.Item
      id={id}
      aria-label={id}
      data-testid={id}
      checked={sectionChecked}
      onChange={() => onSectionChange(id)}
    >
      <Details open>
        <Details.Summary className="nhsuk-u-font-weight-bold">
          Iteration details (
          {selectedItems}
          /1 selected)
        </Details.Summary>

        <Details.Text className="nhsuk-u-margin-top-5">
          <Checkboxes>
            <CheckboxItem
              id={ITERATION_DETAILS.COMMUNICATION}
              aria-label="Communication"
              data-testid={ITERATION_DETAILS.COMMUNICATION}
              label="Communication"
              value={commsTypeToLabel(iteration.CommsType as string)}
              checked={checkedItems[ITERATION_DETAILS.COMMUNICATION]}
              onChange={() => handleCheckboxChange(
                id,
                ITERATION_DETAILS.COMMUNICATION,
              )}
            />
          </Checkboxes>
        </Details.Text>
      </Details>
    </Checkboxes.Item>
  );
}

export default IterationDetailsSection;
